<template>
  <div class="voucher_act">
    <div v-if="!actInfo.id && actInfo.tips" class="error_page">
      {{ actInfo.tips }}
    </div>
    <!-- 图片背景 -->
    <div
      class="header bg_contain"
      :style="{
        backgroundImage: `url(${actInfo.image})`
      }"
    ></div>
    <div class="main">
      <div class="info flex_between mb_8">
        <div v-if="game_account" class="account fs_13">已绑定账号: {{ game_account }}</div>
        <div v-else class="account fs_13" @click="onGoBind">绑定账号</div>
        <div class="go_record fs_13" @click="onClickRecord">领取记录&gt;</div>
      </div>
      <!-- 游戏选择 -->
      <div class="games_select shadow mb_8">
        <div class="games_main">
          <div
            v-for="gm in theTop4Games"
            :key="gm.id"
            class="page_game"
            :class="{ 
              page_game_active: gm.id === activeGameId,
            }"
            @click="handleChangeActiveGame(gm)"
          >
            <div
              class="page_game_icon bg_contain"
              :style="{
                backgroundImage: `url(${gm.icon})`
              }"
            >
              <div
                v-if="gm.id === activeGameId"
                class="page_game_icon_cover bg_contain"
                :style="{
                  backgroundImage: `url(${rootCDNUrl}/selected.png)`
                }"
              >
              </div>
            </div>
          </div>
        </div>
        <div class="page_more flex_center d_flex_col" @click="handleClickMore">
          <div
            class="more_game_icon bg_contain"
            :style="{
              backgroundImage: `url(${rootCDNUrl}/more.png)`
            }"
          ></div>
          <div class="page_game_name mt_3 scale08_center color_red_btn">更多游戏</div>
        </div>
      </div>
      <div class="game_info flex_between mt_8 mb_8">
        <div class="game_name bold">{{ curGame.title }}</div>
        <div class="game_download">
          <div v-if="curGame.download_url" class="download_btn flex_center btn_radius" @click="onClickGoUrl">下载</div>
        </div>
      </div>
      <!-- 单游戏 -->
      <div v-for="group in voucherGroups" :key="group.type" class="single wrap shadow mb_8">
        <div class="single_top pr_16">
          <div class="single_title bold van-ellipsis">{{ group.title }}</div>
        </div>
        <div class="single_main">
          <div
            v-for="it in group.list"
            :key="it.act_dispatch_id"
            class="vc flex_center"
          >
            <div class="vc_img bg_contain" :class="{ vc_img_2: group.type === 2 }"></div>
            <div class="vc_info mr_6 flex_1">
              <div class="vc_title bold fs_13 mb_6">{{ it.name }}</div>
              <div v-if="group.type === 1" class="vc_desc fs_12">活动期间活动页内首次注册</div>
              <div v-if="group.type === 2" class="vc_desc fs_12">活动期间公众号游戏累充达{{ it.condition }}元</div>
            </div>
            <div
              class="vc_btn flex_center btn_radius fs_13"
              :class="{ vc_disabled: it.can_get !== 1 }"
              @click="onReceive(it)"
            >{{ it.can_get === 1 ? '领取' : '已领取' }}</div>
          </div>
        </div>
      </div>
      <!-- 规则 -->
      <div class="single wrap shadow mb_8">
        <div class="single_top pr_16">
          <div class="single_title bold">活动规则</div>
          <!-- <div class="single_btn flex_center btn_radius mt_9">下载</div> -->
        </div>
        <div class="single_main">
          <div class="rule_text" v-html="actInfo.rule"></div>
        </div>
      </div>
    </div>
    <!-- 游戏账号绑定 -->
    <BindAccountDialog
      ref="bindAccountRef"
      :isCommon="false"
      :actId="curId"
      @update="updateGameAccount"
    />
    <Popup
      v-bind="feedback"
      :visible.sync="visible"
      :headerStyle="{ background: '#FE4F4A'}"
      confirmButtonColor="#FE4F4A"
      :showProgress="[5].includes(feedbackType)"
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >
      <template v-if="feedbackType === 2">
        <div class="more_wrap">
          <p class="active_text">请选择</p>
          <div class="more_games">
            <div
              v-for="gm in gameList"
              :key="gm.id"
              class="more_game"
              @click="handleClickGame(gm)"
            >
              <div
                class="more_game_icon bg_contain"
                :style="{
                  backgroundImage: `url(${gm.icon})`
                }"
              ></div>
              <div class="more_game_name scale09_center">{{ gm.title }}</div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="feedbackType === 3">
        <p class="fs_16">每个用户仅可领取一张累充惊喜代金券，确认领取？</p>
        <p class="fs_12 mt_12">如小明领取了一张累充 648 元的代金券，则其余门槛的代金券不可领取</p>
      </template>
    </Popup>
  </div>
</template>

<script>
import { fetchActInfo, fetchUserInfo, fetchGameList, fetchWelfareList, onReceiveApi, onReceivePayApi } from '@/api/voucherAct'
import BindAccountDialog from '@/components/CustomDialogs/BindAccountDialog.vue';
import common from './common.js'
import Popup from '@/components/activityComps/Popup.vue'
const MAP_KEY = 'v_token_map'

export default {
  mixins: [common],
  components: {
    BindAccountDialog,
    Popup,
  },
  data () {
    return {
      rootCDNUrl: 'https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_wxRegister',
      feedbackType: 0,
      visible: false,
      activeGameId: '',
      gameList: [],
      actInfo: {
        id: '',
        tips: '',
      },
      moreGameVisible: false,
      receiveLoading: false,
      voucherGroups: [],
      game_account: '',
      curGift: {},
      progressAttrs: {
        currentVal: 0,
        targetVal: 100,
        skins: {
          color: '#FE4F4A',
          background: '#FE4F4A',
          borderColor: '#FE4F4A',
        },
      },
    }
  },
  activated () {
    if (this.activeGameId) {
      this.EVENT_TRACK(1)
      document.title = res.data.title
    }
  },
  created () {
    this.handleFetchActInfo().then((res) => {
      if (res) {
        this.EVENT_TRACK(1)
        this.handleFetchGameList()
        this.handleFetchUserInfo()
      }
    })
  },
  computed: {
    curGame () {
      return this.gameList.find(v => v.id === this.activeGameId) || {}
    },
    theTop4Games () {
      const gList = this.gameList
      if (!Array.isArray(gList) || !gList.length) return []
      const maxCount = 4
      const currentIdx = gList.findIndex(it => it.id === this.activeGameId)
      const res = [gList[currentIdx]]
      gList.forEach(it => {
        if (res.length === maxCount) return
        if (it.id === this.activeGameId) return
        res.push(it)
      })
      return res 
    },
    feedback () {
      return this.feedbackMap[this.feedbackType] || {}
    },
    feedbackMap () {
      return [
        {
          title: '领取成功',
          message: [
            '您可前往【领取记录】',
            '查看代金券'
          ],
          confirmButtonText: '查看代金券',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
            const { id, act_dispatch_id } = this.curGift
            this.EVENT_TRACK(7, { welfare_id: id, voucher_id: act_dispatch_id })
            this.onGoRecord()
          }
        },
        {
          title: '提示',
          message: [
            '代金券领取失败，',
            '请联系客服'
          ],
          confirmButtonText: '联系客服',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
            this.onGoService()
          }
        },
        {
          title: '更多游戏',
          message: [],
          confirmButtonText: '',
          showConfirmButton: false,
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '温馨提示',
          message: [],
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          showCancelButton: true,
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
            this.onSureReceive(this.curGift, true)
            const { type, condition } = this.curGift
            const plate_info = type === 1? '新用户专享': '累充惊喜'
            this.EVENT_TRACK(10, {
              plate_info: plate_info,
              get_condition: condition,
            })
          }
        },
        {
          title: '温馨提示',
          message: ['您已领取过累充惊喜代金券'],
          confirmButtonText: '去查看',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
            this.onGoRecord()
          }
        },
        {
          title: '任务提示',
          message: [
            '活动期间公众号游戏内',
            `充值金额达到${this.progressAttrs.targetVal}元即可领取奖励`
          ],
          confirmButtonText: '去完成',
          showProgress: true,
          progressAttrs: this.progressAttrs,
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '提示',
          message: ['代金券领取失败，请联系客服'],
          confirmButtonText: '联系客服',
          onCancel: () => {
            this.triggerVisible(false)
          },
          onSure: () => {
            this.triggerVisible(false)
            this.onGoService()
          }
        },
      ]
    },
  },
  methods: {
    handleFetchActInfo () {
      if (!this.curId) return Promise.reject()
      return fetchActInfo(this.curId).then(res => {
        this.actInfo = res.data
        document.title = res.data.title
        return !!res.data.id
      })
    },
    handleFetchGameList (it) {
      if (!this.curId) return
      fetchGameList(this.curId).then(res => {
        const list = res.data
        if (Array.isArray(list)) {
          this.gameList = list
          if (list.length) {
            this.handleChangeActiveGame(it || list[0])
          }
        }
      })
    },
    handleFetchWelfares () {
      fetchWelfareList(this.curId, { game_id: this.activeGameId }).then(res => {
        const list = res.data
        if (Array.isArray(list)) {
          // 新用户专享
          const newList = (list.find(v => v.type === 1) || {}).list || []
          // 累充惊喜
          const payList = (list.find(v => v.type === 2) || {}).list || []

          this.voucherGroups = [
            { title: '新用户专享', type: 1, list: newList },
            { title: '累充惊喜', type: 2, list: payList },
          ].filter(v => v.list.length)
        }
      })
    },
    handleFetchUserInfo () {
      fetchUserInfo(this.curId).then(res => {
        const info = res.data || {}
        this.game_account = info.game_account
      })
    },
    onReceive (it) {
      const { type, condition } = it
      this.EVENT_TRACK(5, {
        plate_info: type === 1 ? '新用户专享': '累充惊喜',
        get_condition: condition,
      })
      if (type === 2) {
        this.onReceiveType2(it)
      } else if (type === 1) {
        this.onSureReceive(it)
      }
    },
    onReceiveType2 (it) {
      if (this.receiveLoading) return
      if (it.can_get !== 1) return
      this.receiveLoading = true
      this.curGift = it
      const { type, condition } = it
      const plate_info = type === 1 ? '新用户专享': '累充惊喜'
      onReceivePayApi(this.curId, {
        game_id: this.activeGameId,
        welfare_id: it.id,
        voucher_id: it.act_dispatch_id,
      }).then(() => {
        // 确认领取
        this.triggerVisible(true, 3)
        this.EVENT_TRACK(9, {
          plate_info: plate_info,
          get_condition: condition,
          pop_type: 2,
        })
      }).catch(err => {
        const { code, data = {}, message } = err
        if (code === 101) {
          // 您已领取过累充惊喜代金券
          this.triggerVisible(true, 4)
          this.EVENT_TRACK(9, {
            plate_info: plate_info,
            get_condition: condition,
            pop_type: 1,
          })
        } else if (code === 102) {
          // 任务未达标
          this.progressAttrs.targetVal = data.target
          this.progressAttrs.currentVal = data.current
          this.triggerVisible(true, 5)
          this.EVENT_TRACK(11, {
            plate_info: plate_info,
            get_condition: condition,
            current_val: data.current
          })
        } else if (code === -1) {
          this.triggerBindAccountDialog(true)
        } else {
          this.$toast.fail(message)
        }
      }).finally(() => {
        this.receiveLoading = false
      })
    },
    // 领取代金券
    onSureReceive (it, isToast = false) {
      // if (!this.validateBinding()) return
      if (this.receiveLoading) return
      if (it.can_get !== 1) return
      this.receiveLoading = true
      this.curGift = it
      const { type, condition } = it
      const plate_info = type === 1 ? '新用户专享': '累充惊喜'
      onReceiveApi(this.curId, {
        game_id: this.activeGameId,
        welfare_id: it.id,
        voucher_id: it.act_dispatch_id,
      }).then(res => {
        if (isToast) {
          this.$toast.success('领取成功，快去游戏内使用吧')
        } else {
          this.triggerVisible(true, 0)
        }
        this.handleFetchWelfares()
      }).catch(err => {
        const { code, message } = err
        if (code === 11) {
          this.triggerVisible(true, 1)
          this.EVENT_TRACK(9, {
            plate_info: plate_info,
            get_condition: condition,
            pop_type: 3,
          })
        } else if (code === -1) {
          this.triggerBindAccountDialog(true)
        } else {
          this.$toast.fail(message)
        }
      }).finally(() => {
        this.receiveLoading = false
      })
    },
    onClickRecord () {
      this.EVENT_TRACK(3)
      if (!this.validateBinding(false)) {
        this.$toast('绑定账号后进入')
        return
      }
      this.onGoRecord()
    },
    // 跳转领取记录
    onGoRecord () {
      this.$router.push({
        name: 'voucherRecord',
        query: {
          id: this.curId,
          origin_id: this.originId,
          gameid: this.activeGameId,
          title: this.curGame.title,
        },
      })
    },
    // 联系客服
    onGoService () {
      this.$router.push({
        name: 'service',
      })
    },
    handleClickGame (gm) {
      this.triggerVisible(false)
      this.handleChangeActiveGame(gm)
    },
    handleClickMore () {
      this.triggerVisible(true, 2)
    },
    handleChangeActiveGame (gm) {
      this.activeGameId = gm.id
      this.handleFetchWelfares()
      this.EVENT_TRACK(2)
    },
    updateGameAccount (token) {
      if (token) {
        this.setToken(token)
        this.handleFetchActInfo().then(res => {
          if (res) {
            this.handleFetchUserInfo()
            this.handleFetchGameList(this.curGame)
          }
        })
      }
    },
    validateBinding (autoTrigger = true) {
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}')
      const CURRENT_KEY = `vToken${this.curId}`
      const token = tokenSet[CURRENT_KEY]
      const isValid = token && token.length && this.game_account
      // 如果没有绑定，则弹出绑定框
      if (!isValid && autoTrigger) {
        this.triggerBindAccountDialog(true)
      }
      return isValid
    },
    setToken (tokenStr) {
      const _KEY = 'vToken' + this.curId
      const tokenSet = JSON.parse(localStorage.getItem(MAP_KEY) || '{}')
      tokenSet[_KEY] = tokenStr
      localStorage.setItem(MAP_KEY, JSON.stringify(tokenSet))
    },
    triggerBindAccountDialog (flag) {
      if (this.$refs.bindAccountRef) {
        this.$refs.bindAccountRef.triggerVisible(flag);
      }
    },
    getUserInfo () {
      this.handleFetchUserInfo()
    },
    onClickGoUrl () {
      this.EVENT_TRACK(4)
      setTimeout(() => {
        this.onGoUrl()
      }, 300)
    },
    // 跳转游戏 url
    onGoUrl () {
      const { download_url } = this.curGame
      if (!download_url) return
      window.open(download_url, '_blank')
    },
    onGoBind () {
      this.EVENT_TRACK(8)
      this.triggerBindAccountDialog(true)
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
  },
}
</script>

<style lang="scss" scoped>
.error_page {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: #f8f8f8;
  color: #919191;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.voucher_act {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  padding-top: 160px;
}
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 220px;
  background-color: #f8f8f8;
}
.main {
  position: relative;
  padding: 0 12px 12px 10px;
  .account {
    color: #fff;
  } 
  .go_record {
    color: #66CEFF;
    white-space: nowrap;
  }
  .games_select {
    position: relative;
    display: flex;
    width: 100%;
    min-height: 76px;
    padding: 16px 60px 6px 14px;
    background-color: #fff;
    border-radius: 10px;
    .games_main {
      display: flex;
      width: 100%;
    }
    .games_more {
      position: absolute;
      bottom: 6px;
      right: 12px;
    }
    .page_game {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100px;
    }
    .page_game_icon {
      width: 54px;
      height: 54px;
      margin-bottom: 4px;
      transition: 0.15s all ease;
      border-radius: 6px;
      flex-shrink: 0;
      .page_game_icon_cover {
        width: 60px;
        height: 60px;
        position: absolute;
        top: -3px;
        left: -3px;
      }
    }
    .more_game_icon {
      width: 37px;
      height: 37px;
    }
    .page_game_name {
      width: 115%;
      font-size: 12px;
      text-align: center;
    }
    .page_game_active {
      opacity: 1;
      .page_game_icon {
        transform: scale(1.14);
        transform-origin: 50% 100%;
        border-radius: 10px;
      }
      .page_game_name {
        width: 130%;
        color: #FAD923;
      }
    }
    .page_more {
      position: absolute;
      bottom: 12px;
      right: 10px;
    }
  }
  .game_info {
    height: 32px;
    .game_name {
      font-size: 20px;
      color: #3F000E;
      padding-left: 12px;
    }
  }
  .download_btn {
    width: 98px;
    height: 32px;
    font-size: 14px;
    color: #fff;
    background: linear-gradient(44deg, rgba(255,142,27,0.87) 0%, rgba(254,184,26,0.87) 90%), rgba(255,255,255,0.72);
  }
  .single {
    .single_top {
      display: flex;
      justify-content: space-between;
    }
    .single_title {
      padding: 0 20px;
      height: 44px;
      line-height: 44px;
      font-size: 18px;
      color: #a1583e;
      background: linear-gradient(180deg, #ffdac8 0%, #fff1e8 100%);
      border-radius: 14px 22px 22px 0px;
    }
    .single_main {
      padding: 10px 10px 14px;
      .vc {
        border-radius: 12px;
        background: #fff;
        padding: 12px 14px 12px 8px;
        .vc_img {
          width: 44px;
          height: 44px;
          margin-right: 12px;
          border-radius: 50%;
          background-image: url('https://image.hzwxbz2.cn/java-yunying/jyy_1723719863661_be558933e768a68c466ec79c086f6609.png');
        }
        .vc_img_2 {
          background-image: url('https://assets.hzwxbz2.cn/sy/wxactivity/img/vc_img_2.png');
        }
        .vc_info {
          width: 0;
        }
        .vc_desc {
          color: #9f7155;
        }
        .vc_btn {
          width: 72px;
          height: 28px;
          background-color: #FF5043;
          color: #fff;
          font-weight: 500;
        }
        .vc_disabled {
          background: #919191;
        }
      }
      .vc + .vc {
        margin-top: 4px;
      }
      .rule_text {
        font-size: 13px;
        line-height: 18px;
        color: #9f7155;
        font-weight: 500;
        white-space: pre-line;
      }
    }
  }
  .wrap {
    width: 100%;
    min-height: 100px;
    background: linear-gradient(180deg,#fff2e9 0%, #fbfbfa 100%);
    border-radius: 12px;
  }
  .shadow {
    box-shadow: 1px 1px 0px 0px rgba(165, 165, 165, 0.60); 
  }
}
.btn_radius {
  border-radius: 100px;
}
.fs_13 {
  font-size: 13px;
}
// 更多游戏
.more_wrap {
  margin-top: 0px;
  .more_games {
    display: flex;
    flex-wrap: wrap;
    padding: 0 12px;
    margin-top: 12px;
    max-height: 260px;
    overflow: auto;
    .more_game {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 84px;
      margin-bottom: 8px;
      .more_game_icon {
        width: 58px;
        height: 58px;
        margin-bottom: 5px;
        border-radius: 6px;
      }
      .more_game_name {
        font-size: 12px;
      }
    }
  }
}
</style>
